/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: '',
    stayConnected: '¡Sigue conectado!',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
  },
  notification: {
    newAndNow: '¡Nuevo y Ahora!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Nueva Insignia',
    'content-update': 'Actualización de Contenido',
    events: 'Eventos',
    other: 'Notificación',
    welcome: 'Bienvenido',
  },
  loginScreen: {
    title:
      'Programa de capacitación de asesores profesionales de turismo y ventas',
    welcome: {
      headerTop: 'Te damos la bienvenida a',
      headerBottom: 'Travel Nevada Ambassador',
    },
    sellingPoints: {
      0: 'Aprende, promociona y vende en el camino',
      1: 'Capacitación multimedia en todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Presentaciones de ventas preparadas con anticipación',
      4: 'Material promocional de gran impacto',
      5: 'Consejos de los expertos y promociones',
      6: 'Directorio de productos en tiempo real',
      7: 'Novedades y actualizaciones periódicas',
    },
    emailPrompt:
      'Ingresa tu dirección de correo electrónico y tu contraseña para confirmar que eres un asesor profesional de turismo.',
    tAndC: {
      agree: 'Al continuar, aceptas nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      agency: 'Agencia',
      salutation: 'Saludo *',
      email: 'Correo electrónico *',
      password: 'Contraseña *',
      passwordConfirm: 'Confirma tu contraseña *',
      firstName: 'Nombre *',
      lastName: 'Apellido *',
      city: 'Ciudad *',
      agencyName: 'Nombre de la agencia *',
      stateProvince: 'Estado/provincia *',
      required: 'Requerido',
      invalidEmail: 'Dirección de correo electrónico no válida',
      opt: '¡Mantente en contacto! ¡Sí, me gustaría optar por recibir comunicaciones de Monaco que me mantengan informado sobre noticias, eventos, incentivos, de FAM y más!',
      complete: 'Paso 2: Complete su perfil',
      tell: 'Cuéntanos sobre ti',
      title: 'Título comercial *',
      host: 'Nombre de la agencia anfitriona',
      country: 'País/Región',
      select: 'Seleccione una opción a continuación',
      header2: '¿Qué segmento(s) vende principalmente?',
      step2: 'Describe tu negocio',
      leisure: 'Ocio',
      corporate: 'Corporativo',
      group: 'Grupo',
      what: '¿Qué tipo de viaje venden?',
      what1: '¿Qué tipo de viaje venden?',
      what2: '¿Cuál es el segundo tipo de viaje que vendes?',
      what3: '¿Cuál es el tercer tipo de viaje que vendes?',
      affiliate: '¿Cuál es su afiliación principal?',
      forgot:
        'Proporcione la dirección de correo electrónico que utilizó cuando se registró en su cuenta de Travel Nevada Ambassador. Le enviaremos un correo electrónico que le permitirá restablecer su contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy un asesor',
      title: 'Agradecemos tu interés en Travel Nevada Ambassador',
      messageWeb:
        'El contenido de este sitio es exclusivo para asesores profesionales de turismo. Para obtener más información sobre Monaco, visita:',
      messageMobile:
        'Algunos contenidos en esta aplicación son exclusivos para asesores profesionales de turismo, pero puedes echar un vistazo a lo que ofrece esta aplicación haciendo clic en "Continuar".',
      continue: 'Continuar',
      visitWebsite: 'Visita el sitio web',
    },
    newUser: 'Nuevo usuario',
    register: 'Regístrate',
    registered: 'Este correo electrónico ya se encuentra registrado',
    forgot: 'Olvidé mi contraseña',
    header:
      'Tómese un momento para completar toda la información a continuación, ya que esto es lo que llenará su perfil e información de contacto.',
    step1:
      'Paso 1: Complete su dirección de correo electrónico y elija una contraseña.',
  },
  welcomeScreen: {
    title: 'Te damos la bienvenida a Travel Nevada Ambassador',
    helloUser: 'Hola, {{name}}',
    hello: 'Hola:',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    introOnline:
      '¡Capacítate de manera inmediata en línea o precarga el contenido para que esté siempre disponible y puedas usarlo sin conexión!',
    introOffline:
      'Ya tienes la última versión precargada. ¡Comienza la capacitación o la venta en cualquier momento y lugar!',
    startTraining: 'Comienza el aprendizaje',
    continueTraining: 'Continúa con el aprendizaje',
    graduated: '¡Felicitaciones!',
    downloader: {
      preload: 'Precargar',
      stop: 'Detener',
      init: 'Iniciando...',
      lastUpdate: 'Última actualización:',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number} % completo',
    unlock:
      'Desbloquea este capítulo completando el capítulo de capacitación {number}.',
    unlockSpecialization: 'Desbloquea este capítulo completando La Fundación',
    unlockSubtitle:
      'Desbloquea más capítulos completando los capítulos de capacitación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificar',
    courseComplete: 'Continuar',
    endReached: 'Has llegado al final',
    retainEnd:
      'Utiliza la barra superior para navegar por este capítulo, o haz clic en el botón "Atrás" para regresar a la descripción general.',
    watchListenRead: 'Mira, escucha y lee más',
    trouble:
      'Parece que tienes problemas, vuelve a leer el contenido de la (las) página(s) anterior(es) e inténtalo nuevamente.',
    confirm: 'Confirma tu respuesta',
    choose: 'Elige una respuesta',
    skip: 'Regresar >',
    viewAllTitle: 'Consejo de capacitación',
    viewAll:
      'Para pasar a la página siguiente, haz clic en los íconos para ver el contenido adicional. Te hemos proporcionado vídeos, mapas y otra información útil para mejorar tu capacitación y asegurarte de que alcances el status PRO.',
    fillBlanks: 'Completa el (los) espacio(s) en blanco:',
    next: 'Siguiente pregunta',
    retry: 'Vuelve a intentarlo',
    fastTrackText: {
      success:
        '¡Felicitaciones, has aprobado el curso Fast Track y has desbloqueado el resto de la capacitación!',
      failed:
        'Desafortunadamente no has aprobado el curso Fast Track. ¡Pero puedes retomar tu capacitación para obtener el diploma!',
    },
    fastTrack: '¡Conviértete en una Swiss Travel Superstar!',
    fastTrackExplanation:
      '¡Solo tienes que completar el cuestionario en las siguientes páginas para tener la oportunidad de ganar un FAM a Suiza!<br><br><span style="font-weight: bold">Encontrarás todas las respuestas a las preguntas de la siguiente manera:</span><br><br>1. El contenido que has aprendido en los módulos Rail Europe y Suiza<br><br>2. Y en los siguientes sitios web:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">¡Asegúrate de revisar estos recursos detalladamente antes de realizar el cuestionario! Solo las personas que hayan obtenido el mayor puntaje tendrán la oportunidad de ser invitadas al FAM.</span>',
    fastTrackButton:
      'Haz clic aquí para responder el cuestionario Swiss Superstar',
    grading: 'Tu puntaje final es: {grade} %',
    badge: 'descargar \n insignia',
  },
  nav: {
    home: 'Inicio',
    train: 'Aprender',
    learn: 'Aprender',
    retain: 'Retener',
    directory: 'Directorio',
    showRoom: 'Exhibiciones',
    showcases: 'Exhibiciones',
    offers: 'Ofertas',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Premios',
    media: 'Medios de comunicación',
    favorites: 'Favoritos',
    contact: 'Información de contacto',
    reportCard: 'Ver diploma',
    accountSettings: 'Ajustes de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Aprender',
    retain: 'Retener',
    subapps: 'Módulos de los asociados de Monaco',
    maintrainings: 'La fundación',
    subtrainings: 'La experiencia',
  },
  pageDescriptions: {
    train: 'Aprende, participa y conviértete en un experto',
    showroom: '',
    retain:
      'Bienvenido a Retener. Una vez completada la formación, este será su recurso de referencia para conservar sus conocimientos especializados y potenciar sus esfuerzos de ventas. Utilice esta área para responder con pericia a preguntas sobre productos o incluso como presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote:
      'Comparte estos elementos para despertar el interés e iniciar una conversación con (posibles) clientes.',
    sell: 'Responde las preguntas y cierra la venta como un experto con recursos consolidados y apoyo comercial específico.',
    favorites: 'Revisa personalmente el contenido de tu preferencia',
    search: 'Revisa todo el contenido',
    subapps: '',
    maintrainings:
      'Comienza por lo básico sobre Monaco los lugares donde se pueden alojar tus clientes.',
    subtrainings:
      'Completa estos módulos sobre todas las increíbles cosas que los clientes pueden hacer y ver en Monaco, y recibe tu certificado como experto oficial en Monaco.',
  },
  general: {
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'No se encontró la imagen',
    noResultsFor: 'No se encontraron resultados para: {{query}}',
    noFavorites: 'Todavía no tienes ningún favorito.',
    noMessages: '¡Aún no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: 'Error 404: ¡no se encontró la página!',
    oops: 'Oh oh...',
    overview: 'Regresar a la descripción general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo completo!',
    chapterComplete: '¡Capítulo completado!',
    message: '{count} mensaje',
    messagePlural: '{count} mensajes',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Colección',
    layout: 'Diseño',
    web: 'Sitio web',
    pdf: 'PDF',
    carousel: 'Colección',
  },
  questions: {
    dials: 'Gira los diales para que coincidan con la respuesta',
    fitb: 'Completa el (los) espacio(s) en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la (las) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Toca la ubicación correcta en el mapa para responder la pregunta',
    dropdown: 'Elige...',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Darse de baja',
    settings: 'Ajustes de privacidad',
    message:
      '¡No nos has comentado nada acerca de tus preferencias sobre la privacidad de datos! Está bien; sin embargo, nos gustaría ofrecerte la mejor experiencia de uso del recurso de ventas.',
    disabled: 'Parece que has deshabilitado el uso de las cookies.',
    use: '{{appName}} requiere el uso de cookies para ofrecerte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Aprende cómo habilitar tus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Visitante',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
  },
  sharing: {
    copyURL: 'Copiar el enlace',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Disfruta de la experiencia completa en la aplicación',
    body: 'Descarga la aplicación tocando uno de los botones de abajo, o busca "{appName}" en tu tienda de aplicaciones.',
    benefits: {
      header: 'Con la aplicación puedes:',
      1: 'Capacitarte en cualquier momento y lugar, incluso sin Wi‑Fi',
      2: 'Acceder a herramientas y recursos de ventas en un solo lugar',
      3: 'Continuar donde lo dejaste en cualquier dispositivo',
    },
    desktop: '¿Prefieres una pantalla más grande? Visita {link} desde tu computadora de escritorio o portátil.',
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de Resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    resetFilters: 'Restablecer Filtros',
    showResults: 'Mostrar Resultados',
    noResults:
      'No se han encontrado resultados. Intente con una búsqueda diferente.',
    resetMap: 'Restablecer mapa para comenzar >',
    viewNow: 'Ver Ahora >',
  },
  directory: {
    attractions: 'Atracciones',
    accommodations: 'Alojamientos',
    dining: 'Restaurantes',
    nightlife: 'Vida Nocturna',
    history: 'Historia/Patrimonio',
    artsculturehistory: 'Arte, Cultura e Historia',
    themeparks: 'Parques Temáticos',
    foodbeverage: 'Comida y Bebida',
    sportsrecreationoutdoors: 'Deportes, Recreación y Aire Libre',
    otheraccommodations: 'Otros Alojamientos',
    shopping: 'Compras',
    weddingservices: 'Servicios de Bodas',
    medicalservices: 'Servicios Médicos',
    golf: 'Golf',
    transportationservices: 'Servicios de Transporte',
    spas: 'Balnearios',
    filters: 'Filtros',
    subFilter: 'Sub Filtros',
    reset: 'Restablecer Filtros',
    other: 'Otro',
    view: 'Ver Ahora',
    amount: 'Cantidad de Resultados',
    museums: 'Museos',
    thingstodo: 'Cosas que Hacer',
    placestostay: 'Lugares para Hospedarse',
    outdoorrecreation: 'Recreación al Aire Libre',
    ghosttowns: 'Pueblos Fantasma',
    shoppingleisure: 'Compras y Ocio',
    fooddrink: 'Comida y Bebida',
    weirdnevada: 'Nevada Extraña',
    weddingsevents: 'Bodas y Eventos',
    artphotographygalleries: 'Galerías de Arte y Fotografía',
    boatingonthewater: 'Navegación y Deportes Acuáticos',
    divingsnorkeling: 'Buceo y Snorkel',
    sightseeingtoursunsetcruises: 'Tours Turísticos y Cruceros al Atardecer',
    ecoturskayakingpaddleboarding: 'EcoTours, Kayak y Paddleboard',
    fishing: 'Pesca',
    beachesparksgardens: 'Playas, Parques y Jardines',
    recreation: 'Recreación',
    museumshistoricsites: 'Museos y Sitios Históricos',
    vehiclebikerentals: 'Alquiler de Vehículos y Bicicletas',
    wildlifeencounters: 'Encuentros con Vida Silvestre',
    performingarts: 'Artes Escénicas',
    hotelsmotelsresorts: 'Hoteles, Moteles y Resorts',
    vacationrentals: 'Alquileres Vacacionales',
    innsbbsguesthouses: 'Posadas, B&Bs y Casas de Huéspedes',
    campingrvscampgrounds: 'Camping, Casas Rodantes y Campamentos',
    uniquestays: 'Alojamientos Únicos',
    rvparkscamping: 'Parques para Casas Rodantes y Camping',
    hotelslodging: 'Hoteles y Alojamiento',
    resortscasinos: 'Resorts y Casinos',
    craftbeverages: 'Bebidas Artesanales',
    barssaloons: 'Bares y Cantinas',
    restaurants: 'Restaurantes',
    localartscene: 'Escena Artística Local',
    wildlifenature: 'Vida Silvestre y Naturaleza',
    offroadingadventure: 'Todo Terreno y Aventura',
    hikingtrails: 'Senderismo y Senderos',
    watersportsfishing: 'Deportes Acuáticos y Pesca',
    spawellness: 'Spa y Bienestar',
    liveperformances: 'Espectáculos en Vivo',
    hotelslodginguniquestays: 'Hoteles y Alojamiento, Alojamientos Únicos',
    uniquestaysrvparkscamping:
      'Alojamientos Únicos, Parques para Casas Rodantes y Camping',
    uniquestayshotelslodging: 'Alojamientos Únicos, Hoteles y Alojamiento',
    hotelslodgingrvparkscamping:
      'Hoteles y Alojamiento, Parques para Casas Rodantes y Camping',
    localartscenehotelslodginguniquestays:
      'Escena Artística Local, Hoteles y Alojamiento, Alojamientos Únicos',
    wildlifenaturehotelslodgingoffroadingadventurervparkscampinguniquestays:
      'Vida Silvestre y Naturaleza, Hoteles y Alojamiento, Todo Terreno y Aventura, Parques para Casas Rodantes y Camping, Alojamientos Únicos',
    uniquestayscraftbeverages: 'Alojamientos Únicos, Bebidas Artesanales',
    uniquestayshotelslodgingresortscasinos:
      'Alojamientos Únicos, Hoteles y Alojamiento, Resorts y Casinos',
    restaurantshotelslodginguniquestaysrvparkscamping:
      'Restaurantes, Hoteles y Alojamiento, Alojamientos Únicos, Parques para Casas Rodantes y Camping',
    wildlifenaturehotelslodgingshoppinguniquestays:
      'Vida Silvestre y Naturaleza, Hoteles y Alojamiento, Compras, Alojamientos Únicos',
    rvparkscampinguniquestays:
      'Parques para Casas Rodantes y Camping, Alojamientos Únicos',
    uniquestaysrvparkscampingbarssaloons:
      'Alojamientos Únicos, Parques para Casas Rodantes y Camping, Bares y Cantinas',
    restaurantshotelslodging: 'Restaurantes, Hoteles y Alojamiento',
    hotelslodgingresortscasinos: 'Hoteles y Alojamiento, Resorts y Casinos',
    resortscasinosshopping: 'Resorts y Casinos, Compras',
    wildlifenatureresortscasinosshopping:
      'Vida Silvestre y Naturaleza, Resorts y Casinos, Compras',
    wildlifenaturehotelslodgingresortscasinosshopping:
      'Vida Silvestre y Naturaleza, Hoteles y Alojamiento, Resorts y Casinos, Compras',
    hotelslodgingshopping: 'Hoteles y Alojamiento, Compras',
    uniquestayshotelslodgingrvparkscamping:
      'Alojamientos Únicos, Hoteles y Alojamiento, Parques para Casas Rodantes y Camping',
    hotelslodgingrestaurantsrvparkscamping:
      'Hoteles y Alojamiento, Restaurantes, Parques para Casas Rodantes y Camping',
    watersportsfishingwildlifenature:
      'Deportes Acuáticos y Pesca, Vida Silvestre y Naturaleza',
    rvparkscampinghikingtrails:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos',
    rvparkscampingwatersportsfishinghikingtrailswildlifenature:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Senderismo y Senderos, Vida Silvestre y Naturaleza',
    rvparkscampingwatersportsfishing:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca',
    hikingtrailswildlifenature:
      'Senderismo y Senderos, Vida Silvestre y Naturaleza',
    shoppingwatersportsfishing: 'Compras, Deportes Acuáticos y Pesca',
    offroadingadventurewildlifenature:
      'Todo Terreno y Aventura, Vida Silvestre y Naturaleza',
    offroadingadventureshopping: 'Todo Terreno y Aventura, Compras',
    rvparkscampinghikingtrailswildlifenature:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos, Vida Silvestre y Naturaleza',
    wildlifenaturehikingtrailsoffroadingadventure:
      'Vida Silvestre y Naturaleza, Senderismo y Senderos, Todo Terreno y Aventura',
    wildlifenatureshopping: 'Vida Silvestre y Naturaleza, Compras',
    wildlifenaturehikingtrails:
      'Vida Silvestre y Naturaleza, Senderismo y Senderos',
    hikingtrailsoffroadingadventurewildlifenature:
      'Senderismo y Senderos, Todo Terreno y Aventura, Vida Silvestre y Naturaleza',
    rvparkscampingwildlifenaturehikingtrailswatersportsfishing:
      'Parques para Casas Rodantes y Camping, Vida Silvestre y Naturaleza, Senderismo y Senderos, Deportes Acuáticos y Pesca',
    wildlifenatureoffroadingadventure:
      'Vida Silvestre y Naturaleza, Todo Terreno y Aventura',
    hikingtrailsoffroadingadventureshopping:
      'Senderismo y Senderos, Todo Terreno y Aventura, Compras',
    rvparkscampingwildlifenaturewatersportsfishinghikingtrails:
      'Parques para Casas Rodantes y Camping, Vida Silvestre y Naturaleza, Deportes Acuáticos y Pesca, Senderismo y Senderos',
    rvparkscampingwildlifenaturehikingtrails:
      'Parques para Casas Rodantes y Camping, Vida Silvestre y Naturaleza, Senderismo y Senderos',
    rvparkscampingwildlifenaturewatersportsfishing:
      'Parques para Casas Rodantes y Camping, Vida Silvestre y Naturaleza, Deportes Acuáticos y Pesca',
    rvparkscampingwildlifenatureoffroadingadventure:
      'Parques para Casas Rodantes y Camping, Vida Silvestre y Naturaleza, Todo Terreno y Aventura',
    rvparkscampinghikingtrailsoffroadingadventurewildlifenature:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos, Todo Terreno y Aventura, Vida Silvestre y Naturaleza',
    rvparkscampingoffroadingadventurewildlifenatureuniquestays:
      'Parques para Casas Rodantes y Camping, Todo Terreno y Aventura, Vida Silvestre y Naturaleza, Alojamientos Únicos',
    rvparkscampingoffroadingadventurewatersportsfishingwildlifenature:
      'Parques para Casas Rodantes y Camping, Todo Terreno y Aventura, Deportes Acuáticos y Pesca, Vida Silvestre y Naturaleza',
    wildlifenaturewatersportsfishing:
      'Vida Silvestre y Naturaleza, Deportes Acuáticos y Pesca',
    rvparkscampinghikingtrailswildlifenatureoffroadingadventure:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos, Vida Silvestre y Naturaleza, Todo Terreno y Aventura',
    rvparkscampingwatersportsfishingoffroadingadventure:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Todo Terreno y Aventura',
    watersportsfishingrestaurantsshopping:
      'Deportes Acuáticos y Pesca, Restaurantes, Compras',
    rvparkscampingwatersportsfishinghikingtrailsoffroadingadventurewildlifenature:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Senderismo y Senderos, Todo Terreno y Aventura, Vida Silvestre y Naturaleza',
    rvparkscampingwatersportsfishinghikingtrailsoffroadingadventure:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Senderismo y Senderos, Todo Terreno y Aventura',
    offroadingadventurehikingtrails:
      'Todo Terreno y Aventura, Senderismo y Senderos',
    wildlifenatureshoppingwatersportsfishing:
      'Vida Silvestre y Naturaleza, Compras, Deportes Acuáticos y Pesca',
    rvparkscampingwatersportsfishingwildlifenature:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Vida Silvestre y Naturaleza',
    wildlifenaturehotelslodging:
      'Vida Silvestre y Naturaleza, Hoteles y Alojamiento',
    hikingtrailsoffroadingadventure:
      'Senderismo y Senderos, Todo Terreno y Aventura',
    watersportsfishinghikingtrailswildlifenature:
      'Deportes Acuáticos y Pesca, Senderismo y Senderos, Vida Silvestre y Naturaleza',
    offroadingadventurewatersportsfishing:
      'Todo Terreno y Aventura, Deportes Acuáticos y Pesca',
    wildlifenatureresortscasinos:
      'Vida Silvestre y Naturaleza, Resorts y Casinos',
    wildlifenaturerestaurantsshopping:
      'Vida Silvestre y Naturaleza, Restaurantes, Compras',
    hikingtrailswatersportsfishingoffroadingadventure:
      'Senderismo y Senderos, Deportes Acuáticos y Pesca, Todo Terreno y Aventura',
    watersportsfishingrvparkscamping:
      'Deportes Acuáticos y Pesca, Parques para Casas Rodantes y Camping',
    rvparkscampingwatersportsfishinghikingtrails:
      'Parques para Casas Rodantes y Camping, Deportes Acuáticos y Pesca, Senderismo y Senderos',
    hikingtrailsshoppingwatersportsfishing:
      'Senderismo y Senderos, Compras, Deportes Acuáticos y Pesca',
    hikingtrailswildlifenaturewatersportsfishing:
      'Senderismo y Senderos, Vida Silvestre y Naturaleza, Deportes Acuáticos y Pesca',
    wildlifenatureoffroadingadventureshopping:
      'Vida Silvestre y Naturaleza, Todo Terreno y Aventura, Compras',
    rvparkscampingshoppingwildlifenature:
      'Parques para Casas Rodantes y Camping, Compras, Vida Silvestre y Naturaleza',
    rvparkscampinghikingtrailsoffroadingadventure:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos, Todo Terreno y Aventura',
    rvparkscampinghikingtrailswildlifenatureoffroadingadventurewatersportsfishing:
      'Parques para Casas Rodantes y Camping, Senderismo y Senderos, Vida Silvestre y Naturaleza, Todo Terreno y Aventura, Deportes Acuáticos y Pesca',
    wildlifenaturemuseums: 'Vida Silvestre y Naturaleza, Museos',
    museumswildlifenature: 'Museos, Vida Silvestre y Naturaleza',
    museumsshopping: 'Museos, Compras',
    localartscenemuseums: 'Escena Artística Local, Museos',
    offroadingadventuremuseums: 'Todo Terreno y Aventura, Museos',
    museumsoffroadingadventure: 'Museos, Todo Terreno y Aventura',
    wildlifenaturemuseumsoffroadingadventure:
      'Vida Silvestre y Naturaleza, Museos, Todo Terreno y Aventura',
    museumsuniquestays: 'Museos, Alojamientos Únicos',
    wildlifenaturemuseumswatersportsfishing:
      'Vida Silvestre y Naturaleza, Museos, Deportes Acuáticos y Pesca',
    restaurantsshopping: 'Restaurantes, Compras',
    shoppinglocalartsceneoffroadingadventure:
      'Compras, Escena Artística Local, Todo Terreno y Aventura',
    shoppingwildlifenature: 'Compras, Vida Silvestre y Naturaleza',
    spawellnessshopping: 'Spa y Bienestar, Compras',
    localartscenerestaurantsshopping:
      'Escena Artística Local, Restaurantes, Compras',
    localartscenewildlifenaturerestaurantsshopping:
      'Escena Artística Local, Vida Silvestre y Naturaleza, Restaurantes, Compras',
    shoppinglocalartscene: 'Compras, Escena Artística Local',
    localartsceneshopping: 'Escena Artística Local, Compras',
    localartsceneliveperformances:
      'Escena Artística Local, Espectáculos en Vivo',
    localartscenewildlifenatureliveperformances:
      'Escena Artística Local, Vida Silvestre y Naturaleza, Espectáculos en Vivo',
    localartscenewildlifenature:
      'Escena Artística Local, Vida Silvestre y Naturaleza',
    localartsceneuniquestays: 'Escena Artística Local, Alojamientos Únicos',
    restaurantsbarssaloons: 'Restaurantes, Bares y Cantinas',
    restaurantscraftbeverages: 'Restaurantes, Bebidas Artesanales',
    restaurantsshoppingcraftbeverages:
      'Restaurantes, Compras, Bebidas Artesanales',
    restaurantsshoppingwildlifenature:
      'Restaurantes, Compras, Vida Silvestre y Naturaleza',
  },
  custom: {
    splitUsers: 'Soy un...',
    brandAmbassador: 'Embajador de la marca',
    travelPro: 'Asesor profesional de turismo',
  },
};
